import styled, { css } from 'styled-components';
import { palette, theme, ifProp } from 'styled-tools';
import { BsThreeDotsVertical, BsTrash } from 'react-icons/bs';
import TextArea from 'react-textarea-autosize';
import { BiLike } from 'react-icons/bi';
import Card from '../Card';

const S = {};

S.TextArea = styled(TextArea)`
  flex: 1;
  display: block;
  border: 0;
  width: 100%;
  height: 39px;
  resize: none;
  border-radius: ${theme('borderRadius.sm')};
  padding: ${theme('spacing.md')} ${theme('spacing.sm')};
  padding-left: ${ifProp('isDraggable', '0', theme('spacing.sm'))};
  background-color: transparent;
  outline: none;
  color: ${palette('colorCardIdea')};
  cursor: ${ifProp('isDraggable', 'initial', 'default')};
  font-size: ${theme('fontSize.xs')};
  line-height: 1.3;
`;

S.IconsHover = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: ${ifProp('isVisible', '14px', '14px 0')};
  border-radius: ${theme('borderRadius.sm')};
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    ${palette('bgCardIdea')} 30%
  );
  opacity: ${ifProp('isVisible', '1', '0')};
  visibility: ${ifProp('isVisible', 'visible', 'hidden')};
  transform: ${ifProp('isVisible', 'scale(1)', 'scale(0)')};
  transition: ${theme('transition')};
`;

S.DeleteIcon = styled(BsTrash)`
  width: 16px;
  height: 16px;
  color: ${palette('asphalt')};
  transition: ${theme('transition')};
  cursor: pointer;
  &:hover {
    color: ${palette('private')};
  }
`;

S.LikeIcon = styled(BiLike)`
  width: 16px;
  height: 16px;
  color: ${ifProp('voted', palette('light'), palette('asphalt'))};
  transition: ${theme('transition')};
  display: block;
  cursor: ${({ isVotable, voted }) =>
    !isVotable && !voted ? 'not-allowed' : 'pointer'};

  &:focus {
    outline: 0;
  }

  ${({ isVotable }) =>
    isVotable &&
    css`
      &:hover {
        color: ${ifProp('voted', palette('light'), palette('primary'))};
      }
    `}
`;

S.WrapperIconVote = styled.div`
  position: relative;
  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    margin-top: -14px;
    margin-left: -14px;
    display: block;
    width: 30px;
    height: 30px;
    background-color: ${ifProp('voted', palette('primary'), 'transparent')};
    border-radius: 50%;
    transition: ${theme('transition')};
  }
`;

S.Wrapper = styled(Card)`
  position: relative;
  display: flex;
  padding: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: ${theme('transition')};

  &:hover {
    ${S.IconsHover} {
      padding: 14px;
      opacity: 1;
      visibility: visible;
      transform: scale(1);
    }
  }
`;

S.Dragger = styled.div`
  display: flex;
  align-items: center;
  padding: 0 5px;
`;

S.DraggerIcon = styled(BsThreeDotsVertical)`
  width: 16px;
  height: 16px;
  color: ${palette('colorCardIdea')};
  &:last-of-type {
    margin-left: -10px;
  }
`;

S.WrapperDragger = styled.div`
  margin-bottom: ${theme('spacing.xs')};

  ${S.Wrapper} {
    background-color: ${ifProp(
      'isDragging',
      palette('bgCardIdeaDragging'),
      ifProp(
        'isCombining',
        palette('bgCardIdeaCombining'),
        palette('bgCardIdea')
      )
    )};
  }

  ${({ isCombining }) =>
    isCombining &&
    css`
      ${S.DraggerIcon} {
        color: ${palette('colorCardIdeaCombining')};
      }

      ${S.TextArea} {
        color: ${palette('colorCardIdeaCombining')};
      }
    `}
`;

export default S;
